import "./_cardOperationCommerciale.scss";

import {ReactElement} from "react";
import {useNavigate} from "react-router-dom";

import iconDL from "@/assets/massification/iconDownload.svg";
import IconLink from "@/assets/massification/iconLink.svg";
import iconUpdate from "@/assets/massification/iconUpdate.svg";
import Button from "@/components/Button/Button";
import {Modale} from "@/components/Modale/Modale";
import {formatDate} from "@/function/formatDate";
import {useRefuseOperation} from "@/hooks/useRefuseOperation";
import {CardOperationCommerciale as operationCommercialeInterface} from "@/ts/interface/operationCommerciale";

function CardOperationCommerciale({
  operation,
  refresh,
}: {
  operation: operationCommercialeInterface;
  refresh: () => Promise<void>;
}): ReactElement {
  const navigate = useNavigate();
  const {handleClickRefuse, modaleInfo} = useRefuseOperation(refresh);

  const handleRefuseOperation = async (): Promise<void> => {
    if (operation?.operation_id) {
      await handleClickRefuse(operation.operation_id);
    }
  };

  return (
    <div className="cardOperation">
      <div className="cardOperation-contenu--left">
        <div className="cardOperation-image">
          {operation.images?.[0]?.url ? (
            <img
              src={operation.images?.[0]?.url}
              alt={`Illustration de l'opération : ${operation.nom}`}
            />
          ) : null}
        </div>
        {operation.obligatoire ? (
          <div className="cardOperation-obligatoire">
            <p>Obligatoire</p>
          </div>
        ) : null}
      </div>
      <div className="cardOperation-contenu--right">
        <h2>
          {operation.nom}
          <span className="cardOperation-date">{` (du ${formatDate(operation.date_validite_debut)} au ${formatDate(operation.date_validite_fin)})`}</span>
        </h2>
        <div
          className="cardOperation-description"
          dangerouslySetInnerHTML={{__html: operation?.description}}></div>
        <div className="cardOperation-telechargement">
          {operation.liens?.map((lien, index) => {
            return (
              <Button
                key={`${lien.nom} ${index}`}
                label={lien.nom}
                variant="validate"
                icon={IconLink}
                onClick={() =>
                  window.open(lien.lien, "_blank", "noopener,noreferrer")
                }
              />
            );
          })}
          {operation?.fichiers?.map(file => {
            return (
              <Button
                key={file.fichierId}
                label={file.nom}
                variant="validate"
                icon={iconDL}
                onClick={() => {
                  window.open(file.url, "_blank");
                }}
              />
            );
          })}
        </div>
        <div className="cardOperation-buttonPasInteresse">
          {!operation.obligatoire &&
          operation.commandee <= 0 &&
          operation.refusee === 0 ? (
            <Button
              label="Refuser"
              variant="negate"
              onClick={() => handleRefuseOperation()}
            />
          ) : null}
        </div>
        <div className="cardOperation-footer">
          <p className="cardOperation-date">{`Engagement du ${formatDate(operation.date_engagement_debut)} au ${formatDate(operation.date_engagement_fin)}`}</p>
          <div className="cardOperation-buttons">
            {operation.refusee <= 0 ? (
              <Button
                label={
                  operation.commandee > 0
                    ? "M'engager de nouveau"
                    : operation.enregistree > 0
                      ? "Continuer mon engagement"
                      : "Je souhaite m'engager"
                }
                icon={operation.enregistree > 0 ? iconUpdate : undefined}
                variant="secondary"
                onClick={() =>
                  navigate(`operation_commerciale/${operation.operation_id}`)
                }
              />
            ) : (
              <p className="operationRefuse">Vous avez refusé cette offre</p>
            )}
            {operation.commandee > 0 ? (
              <Button
                label={`Mes commandes (${operation.commandee})`}
                variant="primary"
                onClick={() => {
                  navigate(
                    `mon_compte/operation_commerciale/${operation.operation_id}`,
                  );
                }}
              />
            ) : null}
          </div>
        </div>
      </div>
      <Modale
        title={modaleInfo.title}
        isOpen={modaleInfo.isOpen}
        variant={modaleInfo.variant}
        close={modaleInfo.close}>
        {modaleInfo.message}
      </Modale>
    </div>
  );
}

export default CardOperationCommerciale;
